export const AccessoryType = {
  STD: 'STD',
  RFQ: 'RFQ',
  UR: 'UR',
  DASH: '-',
  CFG: 'CFG',
} as const;

export type AccessoryType = typeof AccessoryType[keyof typeof AccessoryType];

export const AccessoryDisplayType = {
  visible: 'visible',
  hidden: 'hidden',
  reserved: 'reserved',
} as const;

export type AccessoryDisplayType = typeof AccessoryDisplayType[keyof typeof AccessoryDisplayType];
